<mat-accordion>
  <mat-expansion-panel #searchBoxPanel [expanded]="isExpanded" data-tfa="searchbox-panel">
    <mat-expansion-panel-header>
      <mat-panel-title>{{ title }}</mat-panel-title>
      @if (!searchBoxPanel.expanded) {
        <mat-panel-description>
          <mat-chip-listbox data-tfa="search-box-component-chip-list">
            @for (label of badges; track label) {
              <mat-chip-option [attr.data-tfa]="'search-box-component-chip_' + label"
                               class="large-chips">
                {{ label }}
              </mat-chip-option>
            }
          </mat-chip-listbox>
        </mat-panel-description>
      }
    </mat-expansion-panel-header>
    <div class="custom-search-form">
      <ng-content></ng-content>
    </div>
    <div class="filters-buttons-container">
      <button
        (click)="reinitForm()" [attr.aria-label]="btnReinitText"
        color="accent"
        data-tfa="searchbox-clear-btn"
        mat-raised-button>{{ btnReinitText }}
      </button>
      @if (useSearchBtn) {
        <button
          (click)="searchForm()"
          [attr.aria-label]="btnSearchText" [disabled]="isSearchDisabled"
          color="primary"
          data-tfa="searchbox-search-btn"
          mat-raised-button
        >{{ btnSearchText }}
        </button>
      }
    </div>
  </mat-expansion-panel>
</mat-accordion>
